import { Box as BoxBase, styled } from '@mui/material'

export const Box = styled(BoxBase)`
  &.MuiBox-root {
    margin-top: 64px;
  }
`
